import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-sub-category',
  templateUrl: './listing-sub-category.component.html',
  styles: [
  ],
})
export class ListingSubCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
